export default {
  showStatus: false,
  prospectStatusScreen: '',
}
